var e=(e,p)=>p?{applyToAllEmployees:p,employeeIds:[]}:{applyToAllEmployees:!1,employeeIds:e.map(e=>e.id)};export{e as prepareEmployeeIds};
//# sourceMappingURL=prepareEmployeeIds.js.map